<div class="edit-blended-sec-allocations-component" id="edit-blended-sec-allocations-component" >

  @if (!isUiTest) {
    <irb-inventory-grid id="edit-blended-sec-allocation-grid"
      [style.height] = "height"
      [showSideBar] ='true'
      [rowSelection]="'single'"
      [suppressRowClickSelection] ="false"
      [gridOptions] = "gridOptions"
      [componentName]="componentName"
      [frameworkComponents] = 'frameworkComponents'
      (gridReady) = "onGridReady($event)">
    </irb-inventory-grid>
  }

  <div class="edit-blended-sec-allocation-totas-row" >
    <div>
      Total Security Allocations:
      <div style="position: absolute;top: 5px;padding-right:8px;text-align:right"
        id="edit-blended-sec-allocation-grid-totalper"
      [style]="{color: totalPercent === 100 ? '#188800' : '#C11312'}"></div>
    </div>
  </div>
</div>
